import { SPACE } from './constants';

const SIDES = {
	t: 'top',
	r: 'right',
	b: 'bottom',
	l: 'left',
};

const SIZES = {
	xs: SPACE.XSMALL,
	s: SPACE.SMALL,
	sm: SPACE.SMEDIUM,
	m: SPACE.MEDIUM,
	xm: SPACE.XMEDIUM,
	l: SPACE.LARGE,
	xl: SPACE.XLARGE,
	xxl: SPACE.XXLARGE,
};

export function parseSpace(sides) {
	const paddingAndSides = sides.split(' ');

	return paddingAndSides
		.reduce((accumulator, string) => {
			const side = string.charAt(0);
			const size = string.slice(1);
			if (SIDES[side] && SIZES[size]) {
				accumulator[SIDES[side]] = SIZES[size];
			}

			return accumulator;
		}, {});
}
